//#region import
import React, { useEffect, useState } from 'react'
import {  Chip, Grid, IconButton, Tooltip  } from '@mui/material';
import { useNavigate } from 'react-router';
import { FnAxios, FnDialog } from 'utilities/utilities';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnAddOnTable, BtnEditOnTable } from 'components/Button/ButtonTable';
import { PushPin } from '@mui/icons-material';
import { FilterFieldInterface } from 'components/DataGrid/DataGridProps';
import ChangeOrder from 'components/System/ChangeOrder';
import { EnumStatus } from '../AdminUser/Role/RoleList';
//#endregion

const GalleryList = () => {
    const navigate = useNavigate();
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [lstOrder, setLstOrder] = useState<any>([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression:"nOrder",
        sSortDirection:"asc"
    });

    const dataColumn: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        onClick={() => navigate(`/GalleryForm`)} id={"Add"} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                return [
                    <BtnEditOnTable
                        key={item.row.sID}
                        id="btnEdit"
                        onClick={() => goToEdit(item.row.sID)}
                    />

                ];
            },

        },
        {
            field: "nOrder",
            headerName: "ลำดับ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 100,
            renderCell: (item) => {
                return (
                    <ChangeOrder
                        item={item}
                        value={item.row.nOrder}
                        onChangeOrder={onChangeOrder}
                        optOrder={lstOrder}
                        disabled={false}
                    />
                )
            }
        },
        {
            field: "isPin",
            headerName: "ปักหมุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 100,
            renderCell: (item) => {
                return(
                    <>
                    {!item.row.isPin &&
                        <IconButton aria-label="PushPin" >
                            <PushPin />
                        </IconButton>
                    }
                     {item.row.isPin &&
                        <IconButton aria-label="PushPin" color="error">
                            <PushPin />
                        </IconButton>
                    }
                    </>
                )
            }
        },
        {
            field: "sGalleryName",
            headerName: "ชื่ออัลบั้ม",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            flex: 2,
            width: 220,
        },
        {
            field: "sUpdate1",
            headerName: "วันที่สร้าง",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 120,
        },
        {
            field: "nTotalMenu",
            headerName: "ชื่อผู้สร้าง",
            headerAlign: "center",
            align: "center",
            sortable: true,
            flex: 1,
        },
        {
            field: "sUpdate",
            headerName: "แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 120,
        },
        {
            field: "sStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 120,
            renderCell: (item) => {
                return (
                    <>
                        {EnumStatus.Active == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "rgb(22 187 68)",
                                        backgroundColor: "rgb(231 255 237)",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumStatus.isActive == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "#f1416c",
                                        backgroundColor: "#fff5f8",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                    </>
                )
            }
        },
    ];

    const getTableGallery = (p: PaginationInterface) => {
        setLoadingTable(true);
        let Param = {
            ...p,
        };
        AxiosFn.Post(`Gallery/GetTableGallery`, Param, (result) => {
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: [...result.lstDataGallery],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
            let arrOpt = [];
            for (let i = 1; i <= result.nOrder; i++) {
                arrOpt.push({ label: `${i}`, value: `${i}` });
            }
            setLstOrder([...arrOpt]);
        });
    };

    //#region onChangeOrder
    const onChangeOrder = async (sID, nOrder) => {
        let param = {
            sID: sID,
            NewOrder: nOrder,
            Table: "TbGroupRole",
            Column: "nGroupID",
            TypeColumn: "",
            TypeID: 0
        };
        AxiosFn.Post("Group/OnChangeOrder", param, (res) => {
            getTableGallery(dataRow);
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        });
    };

    //#endregion
    const onDelete = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`Gallery/RemoveDataTableGallery`, { lstID: e }, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success();
                    getTableGallery(dataRow);
                }
            });
        });
    };

    useEffect(() => {
        getTableGallery(dataRow);
    }, []);

    const goToEdit = (sID: string) => {
        navigate(`/GalleryForm?sID=${encodeURI(sID)}`);
    };

    //Filter Search
    const filter: FilterFieldInterface[] = [
        { sTypeFilterMode: "input", sLabel: "ชื่ออัลบั้ม", sFieldName: "sGalleryName", nGridLG: 4, nGridMD: 4, nGridSM: 6, nGridXS: 12 },
        { sTypeFilterMode: "input", sLabel: "ชื่อผู้สร้าง", sFieldName: "sNameForDisplay", nGridLG: 4, nGridMD: 4, nGridSM: 6, nGridXS: 12 },
        {
            sTypeFilterMode: "select", sLabel: "ปักหมุด", sFieldName: "isPin",
            optionSelect: [
                {

                    label: "ปักหมุด",
                    value: "1"
                },
                {

                    label: "ไม่ปักหมุด",
                    value: "0"
                },

            ],
            nGridLG: 2, nGridMD: 2, nGridSM: 6, nGridXS: 12
        },
        { sTypeFilterMode: "date", sLabel: "วันที่สร้าง (เริ่ม)", sFieldName: "dStartDate", nGridLG: 4, nGridMD: 4, nGridSM: 6, nGridXS: 12 },
        { sTypeFilterMode: "date", sLabel: "วันที่สร้าง (สิ้นสุด)", sFieldName: "dEndDate", nGridLG: 4, nGridMD: 4, nGridSM: 6, nGridXS: 12 },
        {
            sTypeFilterMode: "select", sLabel: "สถานะ", sFieldName: "sStatus",
            optionSelect: [
                {

                    label: "ใช้งาน",
                    value: "1"
                },
                {

                    label: "ไม่ใช้งาน",
                    value: "0"
                },

            ],
            nGridLG: 2, nGridMD: 2, nGridSM: 6, nGridXS: 12
        },
    ];
    return (
        <React.Fragment>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <DataGrid
                    sTableID='tb1'
                    columns={dataColumn}
                    rows={dataRow}
                    modeFilter={1}
                    onLoadData={getTableGallery}
                    onDelete={onDelete}
                    isShowCheckBox={true}
                    isLoading={loadingTable}
                    isHiddenToolHead={false}
                    filterField={filter}
                />
            </Grid>
        </React.Fragment >
    )
}
export default GalleryList;
